import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

import useToast from "../useToast"
import { useAuth } from "../useAuth"

import { useMentorCloudCreateFolder } from "./useMentorCloudCreateFolder"

import { CreateFolderFormData, createFolderSchema } from "src/schemas/mentor-cloud/CreateFolderSchema"

export const useMentorCloudCreateFolderForm = (parentFolderId: number | null) => {
    const { notify } = useToast()

    const { user } = useAuth()

    const { control, handleSubmit, formState: { isSubmitting } } = useForm<CreateFolderFormData>({
        resolver: zodResolver(createFolderSchema),
        defaultValues: {
            name: ''
        }
    })

    const { createFolder } = useMentorCloudCreateFolder(parentFolderId)

    const onSubmit = (onSuccess?: () => void) => handleSubmit(async (formData) => {
        try {
            await createFolder({
                values: {
                    name: formData.name,
                    access_type_id: 1,
                    parent_folder_id: parentFolderId,
                    portal_id: user!.portal.id
                }
            })

            onSuccess?.()
        } catch (_error) {
            notify('FOLDER.create', { type: 'error' })
        }
    })

    return {
        control,
        isSubmitting,
        onSubmit
    }
}